import musiciansBanner from '../assets/banners/musicians_banner2.jpg';
import musiciansBanner_sm from '../assets/banners/IMG_5767_sm.jpg';
// import eventsBanner from '../assets/banners/banner_events.webp';
// import homeBanner from '../assets/banners/homeBannerWithNoTitle.webp';
import groupBanner from '../assets/banners/IMG_2260.JPG';
import storyBanner from '../assets/banners/IMG_2260_banner.JPG';
import storyBanner_sm from '../assets/banners/IMG_2260_sm.JPG'
import journeyBanner from '../assets/banners/journey_banner.jpg'


const banners = {
    musicians: {
        musiciansBanner,
        musiciansBanner_sm,
    },
    story: {
        storyBanner,
        storyBanner_sm
    },
    groupBanner,
    journeyBanner
};

export default banners;